import axios from 'axios'

export default {
    get: () => axios.get('schools'),
    list: () => axios.get('schools/list'),
    store: (data) => axios.post('schools/store', data),
    update: (data) => axios.post('schools/update', data),
    delete: (id) => axios.post('schools/delete', id)
}